import React from "react";
import SvgIconDPC from "./dpc-svg-icon";

class DpcPaginator extends React.Component {

    constructor(props) {
        super(props);
        this.itemsPerPage = props.itemsPerPage ? props.itemsPerPage : 10;
        this.numItems = props.numItems ? props.numItems : 0;
        this.numPages = Math.ceil(this.numItems / this.itemsPerPage);
        this.state = {
            currentPage: props.currentPage,
            showLeftEllipsis: false,
            showRightEllipsis: this.numPages > 3,
            timestamp: 1
        };
        this.pages = [];
        //const first = props.currentPage === 1 ? 1 : Math.max(props.currentPage < this.numPages ? props.currentPage - 1 : props.currentPage - 2);
        //const last = this.numPages > 3 ? Math.max(3, props.currentPage + 1) : this.numPages;
        // for (let i = 1; i <= this.numPages; i++){
        //     this.pages.push(i);
        // }
        this.setPage(props.currentPage, true)
    }

    componentDidMount() {
        this.setState({currentPage: this.props.currentPage});
    }

    setPage(page, check = false) {
        page = page > this.numPages ? this.numPages : page < 1 ? 1 : page;
        if (page !== this.state.currentPage || check) {
            const showLeftEllipsis = page > 2;
            const showRightEllipsis = this.numPages > 3 && (page < this.numPages - 1);
            this.pages = [];
            const first = showLeftEllipsis ? Math.max(page < this.numPages ? page - 1 : page - 2) : 1;
            const last = showRightEllipsis ? Math.max(3, page + 1) : this.numPages;
            for (let i = first; i <= last; i++)
                this.pages.push(i);
            this.setState({
                currentPage: page,
                showLeftEllipsis: showLeftEllipsis,
                showRightEllipsis: showRightEllipsis
            });
            if (typeof this.props.setPage === "function") {
                this.props.setPage(page);
            } else {
                console.warning("Non è stata predisposta una funzione setPage, quindi il cambio pagina non sortisce nessun effetto sulla view dei contenuti!")
            }
        }
    }

    checkCurrent(page){
        if(page === this.state.currentPage) {
            return 'page';
        } else {
            return null
        }
    }

    render() {
        if (this.numPages > 1)
            return (
                <nav className="pagination-wrapper justify-content-center" aria-label="Navigazione articoli">
                    <ul className="pagination">
                        <li className="page-item">
                            <a className="page-link" style={{'cursor': 'pointer'}} onClick={event => this.setPage(1)}
                               tabIndex="-1" aria-hidden="true">
                                <svg viewBox="0 0 16 16" className="icon bi bi-chevron-double-left"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd"
                                          d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path>
                                    <path fillRule="evenodd"
                                          d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"></path>
                                </svg>
                                <span className="sr-only">Prima pagina</span>
                            </a>
                        </li>
                        <li className="page-item">
                            <a className="page-link" style={{'cursor': 'pointer'}} aria-hidden="true"
                               onClick={event => this.setPage(this.state.currentPage - 1)} tabIndex="-1">
                                <SvgIconDPC name='chevron-left'/>
                                <span className="sr-only">Pagina precedente</span>
                            </a>
                        </li>
                        {/*
                            this.state.showLeftEllipsis &&
                            <li className="page-item">
                                <a className="page-link">...</a>
                            </li>
                        */}
                        
                        {
                            this.pages.map(page =>{
                                return (<li className="page-item">
                                    <a className="page-link" style={{'cursor': 'pointer'}}
                                       onClick={event => this.setPage(page)}
                                       aria-current={this.checkCurrent(page)}>
                                        {/*<span className="d-inline-block d-sm-none">Pagina </span>*/}
                                        {page}
                                    </a>
                                </li>)}
                            )
                        }
                        {/*
                            this.state.showRightEllipsis &&
                            <li className="page-item">
                                <a className="page-link">...</a>
                            </li>
                        */}
                        <li className="page-item">
                            <a className="page-link" style={{'cursor': 'pointer'}}
                               onClick={event => this.setPage(this.state.currentPage + 1)}>
                                <span className="sr-only">Pagina successiva</span>
                                <SvgIconDPC name='chevron-right'/>
                            </a>
                        </li>
                        <li className="page-item">
                            <a className="page-link" style={{'cursor': 'pointer'}}
                               onClick={event => this.setPage(this.numPages)}>
                                <span className="sr-only">Ultima pagina</span>
                                <svg width="1.125em" height="1.125em" viewBox="0 0 16 16"
                                     className="bi bi-chevron-double-right" xmlns="http://www.w3.org/2000/svg">
                                    <path fillRule="evenodd"
                                          d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708z"></path>
                                    <path fillRule="evenodd"
                                          d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708z"></path>
                                </svg>
                            </a>
                        </li>
                    </ul>
                </nav>
            );
        return ("");
    }
}

export default DpcPaginator;
